
const defaultState = {
  isOpen: false,
  event: null,
  defaultTab: 'signIn',
};


const modal = (state = defaultState, action) => {
  switch (action.type) {
    case 'OPEN_MODAL':
      return Object.assign({}, state, { isOpen: true, event: action.event });
    case 'CLOSE_MODAL':
      return Object.assign({}, state, { isOpen: false });
    case 'CHANGE_DEFAULT_TAB':
      return Object.assign({}, state, { defaultTab: action.newDefaultTab });
    default:
      return state;
  }
};

export default modal;
